import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Accept Assignment Request Schema
 * POST /api/v2/process-step-assignment/:id/accept
 * Assignment ID provided as URL parameter
 */ export const AcceptAssignmentRequestSchema = z.void();
/**
 * Accept Assignment Response Schema
 * Returned on successful assignment acceptance
 * Contains the ID of the created process step recording
 */ export const AcceptAssignmentResponseSchema = z.object({
    processStepRecordingId: z.string()
});
/**
 * Accept Assignment Error Schema
 * Returned when assignment acceptance fails
 */ export const AcceptAssignmentErrorSchema = BaseErrorSchema;

//# sourceMappingURL=accept-assignment.schema.js.map